import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GeneralInformationBanner } from '../../components/GeneralInformationBanner/GeneralInformationBanner';
import { usePlayConfig } from '../../config/PlayConfigContext';
import { usePrivacyDispatch } from '../PrivacyProvider/PrivacyContext';
import { useUcEvent } from '../use-uc';
import { jsx as _jsx } from "react/jsx-runtime";
const cmpLoadErrorType = 'CMP_Load_Error';
export const PrivacyBanner = ({
  suppressBanner = false
}) => {
  const {
    t
  } = useTranslation();
  const [hasError, setHasError] = useState(false);
  const {
    privacyBanner: {
      isEnabled
    }
  } = usePlayConfig();
  const dispatchPrivacy = usePrivacyDispatch();
  const isConsentRequired = isEnabled && !suppressBanner;
  useUcEvent();
  useEffect(() => {
    dispatchPrivacy({
      type: 'set-requirement',
      isRequired: isConsentRequired
    });
  }, [dispatchPrivacy, isConsentRequired]);
  useEffect(() => {
    const unsubscribe = window.__PubSub_PLAY__.subscribe('cmpLoadError', setHasError);
    return () => {
      unsubscribe();
    };
  }, []);
  const cmpLoadErrorMessage = {
    id: cmpLoadErrorType,
    text: t('cmp.loadError')
  };
  return hasError && cmpLoadErrorMessage.text ? /*#__PURE__*/_jsx(GeneralInformationBanner, {
    message: cmpLoadErrorMessage,
    onClose: () => setHasError(false)
  }) : null;
};